export default __webpack_public_path__ + "static/media/graignes6.b0e6e501.jpg";